import React from 'react';
import './PetAnimations.css';

export default function HorseSvg({ size = 120, color, className = '' }) {
  const bodyColor = color || '#8B5E3C';
  const lightColor = color ? lighten(color) : '#A8784E';
  const darkColor = color ? darken(color) : '#5C3D22';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      className={`pet-svg pet-idle ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Tail */}
      <path
        d="M92 65C100 60 108 55 106 48C104 42 98 50 96 56C94 60 92 64 90 66"
        stroke={darkColor}
        strokeWidth="4"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M92 65C102 62 110 58 108 52"
        stroke={darkColor}
        strokeWidth="3"
        strokeLinecap="round"
        fill="none"
      />
      {/* Body */}
      <ellipse cx="62" cy="65" rx="30" ry="20" fill={bodyColor} />
      {/* Belly highlight */}
      <ellipse cx="60" cy="72" rx="18" ry="10" fill={lightColor} />
      {/* Back legs */}
      <rect x="76" y="78" width="10" height="22" rx="4" fill={bodyColor} />
      <rect x="82" y="78" width="10" height="22" rx="4" fill={darkColor} />
      {/* Front legs */}
      <rect x="34" y="76" width="10" height="24" rx="4" fill={bodyColor} />
      <rect x="28" y="76" width="10" height="24" rx="4" fill={darkColor} />
      {/* Hooves */}
      <rect x="27" y="98" width="12" height="5" rx="2" fill="#2C2419" />
      <rect x="33" y="98" width="12" height="5" rx="2" fill="#2C2419" />
      <rect x="75" y="98" width="12" height="5" rx="2" fill="#2C2419" />
      <rect x="81" y="98" width="12" height="5" rx="2" fill="#2C2419" />
      {/* Neck */}
      <path d="M38 60C34 50 30 40 32 32L48 30L46 58Z" fill={bodyColor} />
      {/* Head - long face */}
      <ellipse cx="34" cy="30" rx="14" ry="12" fill={bodyColor} />
      <ellipse cx="30" cy="34" rx="10" ry="8" fill={lightColor} />
      {/* Mane */}
      <path d="M42 22C44 18 42 14 40 18C38 14 36 10 34 16C32 12 30 8 28 14C26 10 24 14 26 18" stroke={darkColor} strokeWidth="3" strokeLinecap="round" fill="none" />
      <path d="M44 28C46 24 44 30 42 34C42 38 40 42 38 46" stroke={darkColor} strokeWidth="4" strokeLinecap="round" fill="none" />
      {/* Ears */}
      <path d="M28 18L24 8L32 16Z" fill={bodyColor} />
      <path d="M40 18L44 8L36 16Z" fill={bodyColor} />
      <path d="M29 17L26 11L32 16Z" fill="#E8A0A0" />
      <path d="M39 17L42 11L36 16Z" fill="#E8A0A0" />
      {/* Eyes */}
      <ellipse cx="28" cy="26" rx="3" ry="3.5" fill="white" />
      <ellipse cx="40" cy="26" rx="3" ry="3.5" fill="white" />
      <ellipse cx="29" cy="26" rx="2" ry="2.5" fill="#2C2419" />
      <ellipse cx="41" cy="26" rx="2" ry="2.5" fill="#2C2419" />
      <circle cx="30" cy="25" r="0.8" fill="white" />
      <circle cx="42" cy="25" r="0.8" fill="white" />
      {/* Nostrils */}
      <ellipse cx="25" cy="35" rx="1.5" ry="1" fill={darkColor} />
      <ellipse cx="31" cy="35" rx="1.5" ry="1" fill={darkColor} />
      {/* Mouth */}
      <path d="M24 38C26 39 30 39 32 38" stroke={darkColor} strokeWidth="0.8" strokeLinecap="round" fill="none" />
    </svg>
  );
}

function lighten(hex) {
  const r = Math.min(255, parseInt(hex.slice(1, 3), 16) + 40);
  const g = Math.min(255, parseInt(hex.slice(3, 5), 16) + 40);
  const b = Math.min(255, parseInt(hex.slice(5, 7), 16) + 40);
  return `rgb(${r},${g},${b})`;
}

function darken(hex) {
  const r = Math.max(0, parseInt(hex.slice(1, 3), 16) - 30);
  const g = Math.max(0, parseInt(hex.slice(3, 5), 16) - 30);
  const b = Math.max(0, parseInt(hex.slice(5, 7), 16) - 30);
  return `rgb(${r},${g},${b})`;
}
